"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const classnames_1 = __importDefault(require("classnames"));
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const List_1 = __importDefault(require("@mui/material/List"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListSubheader_1 = __importDefault(require("@mui/material/ListSubheader"));
const MenuList_1 = __importDefault(require("@mui/material/MenuList"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const DoneRounded_1 = __importDefault(require("@mui/icons-material/DoneRounded"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const AmountField_1 = require("components/QuickenControls/AmountField");
const searchFilter_1 = require("data/transactions/searchFilter");
const styles_1 = __importDefault(require("./styles"));
const DATE_FORMAT = 'MM/dd/yyyy';
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const commonStyles = (flex, textAlign, minWidth) => ({ flex, textAlign, minWidth });
const TransactionSelectList = (props) => {
    const { classes, theme } = useStyles();
    let cols = [
        { label: 'Clr', flex: 1, field: 'state', align: 'center' },
        { label: 'Date', flex: 2, field: 'postedOn', align: 'left', minWidth: 85 },
        { label: 'Posted', flex: 2, field: 'posting', align: 'left', minWidth: 85 },
    ];
    if (props.accountType !== 'CREDIT') {
        cols.push({ label: 'Chk#', flex: 2, field: 'check', align: 'left' });
    }
    cols = cols.concat([
        { label: 'Payee', flex: 3, field: 'payee', align: 'left' },
        { label: 'Amount', flex: 2, field: 'amount', align: 'right', padding: 2 },
    ]);
    const [totalAmount, setTotalAmount] = (0, react_1.useState)(props.transactions.reduce((v, txn) => v + (txn.state === 'CLEARED' ? Number(txn.amount) : 0), 0.0));
    const getStringForField = (txn, field) => {
        switch (field) {
            case 'posting':
                return txn.cpData ? luxon_1.DateTime.fromISO(txn.cpData.postedOn).toFormat(DATE_FORMAT) : '';
            case 'postedOn':
                return luxon_1.DateTime.fromISO(txn.postedOn).toFormat(DATE_FORMAT);
            case 'state':
                return txn.state === 'CLEARED' ? <DoneRounded_1.default sx={{ color: 'green1' }}/> : '';
            default:
                return (0, searchFilter_1.getFieldString)(field, txn.toJS());
        }
    };
    const transactionClick = (txn) => {
        if (props.onClick) {
            props.onClick(txn);
        }
    };
    const renderTxRow = (title, txn, columns) => {
        const ret = [];
        columns.forEach((col) => {
            ret.push(<div key={`${title}:${txn.id}:${col.label}`} className={classes.divTxnRow} style={commonStyles(col.flex, col.align, col.minWidth)}>
          <QTip_1.default wrapOnly title={String(getStringForField(txn, col.field))}>
            <Typography_1.default variant="body2" className={(0, classnames_1.default)(classes.txField, txn.state === 'CLEARED' ? 'cleared' : '')}>
              {getStringForField(txn, col.field)}
            </Typography_1.default>
          </QTip_1.default>
        </div>);
        });
        return ret;
    };
    const renderTransactions = (title, transactions, columns) => {
        const ret = [];
        transactions.reverse().forEach((txn) => {
            ret.push(<MenuItem_1.default key={`txrowrecon:${title}-${txn.id}`} classes={{ selected: classes.selectedItem, root: classes.listRoot }} onClick={() => transactionClick(txn)} divider>
          <div className={classes.txRow}>
            {renderTxRow(title, txn, columns)}
          </div>
          <Divider_1.default />
        </MenuItem_1.default>);
        });
        return (<MenuList_1.default classes={{ root: classes.listRoot }} dense disablePadding onKeyDown={props.onKeyDown}>
        {ret}
      </MenuList_1.default>);
    };
    const prevTransactions = (0, react_use_1.usePrevious)(props.transactions);
    (0, react_1.useEffect)(() => {
        if (props.transactions !== prevTransactions) {
            setTotalAmount(props.transactions.reduce((v, txn) => v + (txn.state === 'CLEARED' ? Number(txn.amount) : 0), 0));
        }
    }, [props.transactions, prevTransactions]);
    return (<List_1.default className={props.className} classes={{ root: classes.listRoot }} dense disablePadding subheader={<div />} onKeyDown={props.onKeyDown} id={props.id}>
      <ListSubheader_1.default disableGutters sx={{ background: theme.palette.white }}>
        <div className={classes.listRoot}>
          <div className={classes.titleWrapper}>
            <Typography_1.default variant="subtitle2">
              {props.title}
            </Typography_1.default>
          </div>
        </div>

        <div className={classes.listRoot}>
          <div className={classes.colsWrapper}>
            {cols.map((col) => (<div key={`${props.title}:header:${col.label}`} style={Object.assign(Object.assign({}, commonStyles(col.flex, col.align, col.minWidth)), { paddingRight: col.padding, background: theme.palette.silverGrey })}>
                <Typography_1.default variant="subtitle2">
                  {col.label}
                </Typography_1.default>
              </div>))}
          </div>
        </div>
      </ListSubheader_1.default>
      {renderTransactions(props.title, props.transactions, cols)}
      {props.showTotals && (<ListItem_1.default classes={{ root: classes.listRoot }}>
          <div className={(0, classnames_1.default)(classes.colsWrapper, classes.divListItem)}>
            {cols.map((col) => (<div key={`${props.title}:footer:${col.label}`} className={classes.divListItemColumn} style={commonStyles(col.field === 'amount' || col.field === 'state' ? 4 : 0, col.field === 'state' ? 'left' : col.align, col.field === 'amount' || col.field === 'state' ? col.minWidth : null)}>
                <Typography_1.default variant="subtitle2" className={classes.listFooter}>
                  {col.field === 'state' ? `Cleared ${props.title}` : ''}
                  {col.field === 'amount' ? (0, AmountField_1.formatNumber)(totalAmount, props.currencyString, '0,00.00') : ''}
                </Typography_1.default>
              </div>))}
          </div>
        </ListItem_1.default>)}
    </List_1.default>);
};
exports.default = TransactionSelectList;
